module.exports = __webpack_public_path__ + "static/media/xuyiyang.2230bced.png";